import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

export const ReturnFreightDiscountSchema: RegistryItem = {
	[AgreementTypeEnum.ReturnFreightDiscount]: {
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
	},
};
